import React from 'react';
import { IconSvgProps } from '@models/common';

const LinesSparkle: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M21.5406 3.39087C22.2033 3.39087 22.7406 3.92813 22.7406 4.59087C22.7406 5.25361 22.2033 5.79087 21.5406 5.79087H3.76677C3.10403 5.79087 2.56677 5.25361 2.56677 4.59087C2.56677 3.92813 3.10403 3.39087 3.76677 3.39087H21.5406Z'
        fill='currentColor'
      />
      <path
        d='M8.21052 10.0562C8.87318 10.0563 9.41052 10.5935 9.41052 11.2562C9.41052 11.9189 8.87318 12.4561 8.21052 12.4562H3.76677C3.10403 12.4562 2.56677 11.9189 2.56677 11.2562C2.56677 10.5935 3.10403 10.0562 3.76677 10.0562H8.21052Z'
        fill='currentColor'
      />
      <path
        d='M8.21052 16.7215C8.87318 16.7216 9.41052 17.2589 9.41052 17.9215C9.41052 18.5842 8.87318 19.1214 8.21052 19.1215H3.76677C3.10403 19.1215 2.56677 18.5843 2.56677 17.9215C2.56677 17.2588 3.10403 16.7215 3.76677 16.7215H8.21052Z'
        fill='currentColor'
      />
      <path
        d='M16.4879 9.10611C16.6222 8.74331 17.1359 8.74331 17.2702 9.10611L18.6146 12.7395C18.6354 12.7959 18.6682 12.8471 18.7107 12.8897C18.7531 12.9322 18.8043 12.965 18.8606 12.986L22.4944 14.3304C22.8572 14.4647 22.8572 14.9784 22.4944 15.1127L18.8611 16.4572C18.8047 16.478 18.7535 16.5107 18.7109 16.5532C18.6684 16.5957 18.6355 16.6468 18.6146 16.7032L17.2702 20.3366C17.1359 20.6998 16.6222 20.6998 16.4879 20.3366L15.1434 16.7036C15.1226 16.6472 15.0899 16.596 15.0474 16.5535C15.0049 16.5109 14.9538 16.4781 14.8974 16.4572L11.2636 15.1127C10.9008 14.9784 10.9008 14.4647 11.2636 14.3304L14.897 12.986C14.9534 12.9651 15.0046 12.9324 15.0471 12.8899C15.0897 12.8474 15.1225 12.7963 15.1434 12.7399L16.4879 9.10611Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default LinesSparkle;
